<template>
  <div class="model_instance">
    <div class="model_instance__header">
      <h4 class="title">
        {{ translate("server.instance_group.add_group_instance") }}
      </h4>
    </div>

    <div class="model_instance__body">
      <div class="instance">
        <div class="row">
          <div class="col-md-12">
            <fg-input
                v-model="new_group.name"
                type="text"
                :label="translate('server.instance_group.name')"
                :placeholder="translate('server.instance_group.name')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 form-group">
            <label> {{ translate('server.instance_group.server') }} </label>
            <tree-select
                v-model="new_group.server_id"
                :options="server_list"
                :placeholder="translate('server.instance_group.server')"
                :clearable="false"
                :searchable="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text_wrap">
            <div class="form-group">
              <label>{{ translate('server.instance_group.descr') }}</label>
              <textarea class="input_text" rows="8" v-model="new_group.descr" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_instance__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="save_group"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

export default {
  name: 'AddInstance',
  data () {
    return {
      new_group: {
        name: "",
        descr: "",
        server_id: null
      },
      servers: []
    }
  },

  computed:{
    server_list(){
      return this.$store.getters.getServerList.map(server => {
        return {id: server.id, label: server.name}
      })
    },
  },
  methods: {
    // get_servers(){
    //   this.$http.v1.getServers({}, (response) => {
    //     this.servers = response.data
    //   })
    // },
    save_group(){
      this.$http.v1.createServerInstanceGroup(this.new_group, () => {
        this.global_notify('info', this.translate('server.instance_group.saved_group_instance_success'))
        this.$emit("update")
      })
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_instance{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      height: 400px;
      .instance{
        width: 100%;
        height: 100%;
        .line{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .input_wrap{
            width: 100%;
            text-align: start;
            margin-bottom: 10px;
          }

          .form-group,
          .vue-treeselect{
            margin-bottom: 0;
          }
        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
